'use client';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import reactHtmlParser from 'react-html-parser';
import Title from '@/components/common/ui/text/Title';
import Link from 'next/link';
import { StyledInstruments } from '@/components/common/ygen/sections/instruments/instruments.style';

const JobList = ({ data, background, parentProduct, padding, getProductCategory, getProductDataJson }) => {
	const [getCategoryData, setCategoryData] = useState(getProductCategory); // Store scroll data in state

	const [getProductData, setProductData] = useState(
		getProductDataJson?.filter(f => f?.product_data?.parent_product_id === parentProduct && f?.product_data?.product_brand_id === data?.data?.category_id) || []
	);



	useEffect(() => {
		if (getProductCategory) {
			const onlyProducts = getProductCategory.filter(item => item?.type === 3);
			setCategoryData(onlyProducts);
		}
		if (getProductDataJson) {
			setProductData(getProductDataJson?.filter(f => f?.product_data?.parent_product_id === parentProduct) || []);
		}
	}, [getProductCategory, getProductDataJson, setCategoryData, setProductData]);



	return (
		<StyledInstruments background={background} classsName={`productList instruments-list ${padding ? padding : 'pt200 pb200'}`} data-scroll-section>
			<Container className={'mb80'}>
				<Row>
					<Col md={3}>
						<p className={'subtitle-ygen'}>
							Real Results, Proven Success
						</p>
					</Col>
					{

						<Col md={8}>
							{

								data?.data?.subtitle &&
								<Title tag={'h3'} margin={'0 0 20px'} text={data?.data?.subtitle} color={'#152637'} />


							}
							{
								data?.data?.description &&
								reactHtmlParser(data?.data?.description)

							}


						</Col>
					}

				</Row>
			</Container>
			<Container>
				<Row>
					{
						getProductData &&
						getProductData?.length > 0 &&
						getProductData?.map((e,index) => {


							if (parseInt(data?.data?.category_id) === parseInt(e?.product_data?.product_brand_id)){
								const thumb = e?.images?.list?.find((f) => f?.thumb === 'on');



								return(
									<Col md={3} key={index}>
										<Link href={`/product/category/${e?.product_data?.slug}`}></Link>
										<div className="single-item">
											<div className="item-image">
												<img src={thumb?.full_path ? thumb?.full_path : '/images/static/blur.jpg'} alt={e?.product_data?.title} />
											</div>
										</div>
										<p>{e?.product_data?.title}</p>


									</Col>
								)
							}


						})
					}
				</Row>
			</Container>
		</StyledInstruments>
	);
};



export default React.memo(JobList);
